<template>
  <div class="card is-insight is-padded">
    <header class="card-header">
      <div class="card-header-start">
        <div class="card-header-title">
          Insights
          <div class="tooltip-container">
            <i class="material-icons">&#xE887;</i>
            <div class="tooltip tooltip-top" role="tooltip">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Exercitationem corporis mollitia commodi labore atque natus maxime deleniti qui laudantium doloribus laboriosam sint eveniet, numquam iusto quia nihil explicabo ipsum doloremque!
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="card-content">
      <error-state type="placeholder" :is-insights="true" class="is-small" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationTypeOverviewInsightsCard',
};
</script>

<style lang="scss" scoped>
</style>